import styled from 'react-emotion'
import Label from '../../../../common/components/Label'

export const UsageBar = styled(Label)(({ usage }) => ({
  position: 'relative',
  '&:before': usage < 1 && {
    //usage indicator
    content: '""',
    position: 'absolute',
    left: 0,
    height: '100%',
    width: usage * 100 + '%',
    maxWidth: '100%',
    background: '#DDD'
  },
  // other things on top of usage indicator
  '*': { zIndex: 1 }
}))

export default UsageBar
